module.exports = __webpack_public_path__ + "img/sn-guide.be159e15.png";